import styled from 'styled-components'

export const ShapeWrapper = styled.span`
  display: block;
  position: absolute;
  z-index: ${({ zindex }) => zindex || 0};
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  top: ${({ posiTop }) => posiTop}%;
  bottom: ${({ posiBottom }) => posiBottom}%;
  left: ${({ posiLeft }) => posiLeft}%;
  right: ${({ posiRight }) => posiRight}%;

  ${({ rotate }) =>
    rotate &&
    `
    transform: rotate(${rotate}deg);
  `};

  .shape-gradient {
    width: 0;
    height: 0;
    position: absolute;
  }

  .shape-element {
    width: 100% !important;
    height: 100% !important;
    color: ${({ theme, color }) => theme.color[color]};

    > * {
      ${({ theme, gradient, gradientUUID, color }) =>
        gradient &&
        `
        fill: url(#${gradientUUID}) ${theme.color[color]};
      `}
    }
  }
`
